export const PolicyManagementIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6663 8.03349V5.1935C13.6663 2.50684 13.0397 1.8335 10.5197 1.8335H5.47968C2.95968 1.8335 2.33301 2.50684 2.33301 5.1935V12.7002C2.33301 14.4735 3.30635 14.8935 4.48635 13.6268L4.493 13.6202C5.03967 13.0402 5.873 13.0868 6.34633 13.7202L7.01967 14.6202"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33301 5.1665H10.6663"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7.8335H10"
        stroke="#010D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.141 10.3469L9.78101 12.7069C9.68768 12.8002 9.601 12.9735 9.581 13.1002L9.45433 14.0002C9.40766 14.3269 9.63434 14.5535 9.961 14.5069L10.861 14.3802C10.9877 14.3602 11.1677 14.2735 11.2543 14.1802L13.6143 11.8202C14.021 11.4135 14.2143 10.9402 13.6143 10.3402C13.021 9.74686 12.5477 9.94018 12.141 10.3469Z"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7998 10.687C11.9998 11.407 12.5598 11.967 13.2798 12.167"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
